module.exports = __webpack_public_path__ + "static/img/gd-03.75cd3494.jpg";